import React from "react"
import { graphql } from "gatsby"
import { getImage, GatsbyImage } from "gatsby-plugin-image"
import { RiFacebookFill, RiInstagramLine } from "react-icons/ri"
import Layout from "../components/layout"
import Seo from "../components/seo"
import { useSiteMetadata } from "../hooks/useSiteMetadata"
import ContactMeForm from "../components/forms/contactMeForm"

export const query = graphql`
  {
    datoCmsAsset(filename: { eq: "71-burriss-st-google-maps.png" }) {
      gatsbyImageData(
        imgixParams: {
          w: "1024"
          auto: "compress,enhance,format"
          q: 85
          # fit: "fillmax"
        }
        placeholder: BLURRED
        width: 1024
        layout: FULL_WIDTH
      )
    }
  }
`

export default function ContactPage({ data }) {
  const siteMetadata = useSiteMetadata().datoCmsCompany
  const certificates = useSiteMetadata().datoCmsCompany.certificates
  return (
    <Layout
      bg={data.datoCmsAsset}
      heroH1="Contacts & About Me"
      heroText="Welcome to my home studio👋, where you will find professional salon services in a cozy home atmosphere."
      heroCta="Book Appointment"
      breadCrumbs={[
        { name: "Salon Thunder Bay", url: "/", active: false },
        { name: "Contacts", url: "/contacts/", active: true },
      ]}
    >
      <Seo
        title="Contacts"
        description="Find Contacts of my Nail Salon! Professional Salon Services in a Cozy Home Studio."
        pageSlug="/contacts/"
      />
      <section className="bg-slate-50 py-24 px-4 sm:px-8 xl:px-24">
        <div className="text-4xl md:text-5xl font-playfaird font-medium leading-ok md:leading-ok">
          Contact Me
        </div>
        <hr className="max-w-[200px] my-4 border-amber-200 border" />
        <p className="max-w-xl my-8">
          I make all kinds of manicures and pedicures, nail designs, gel and
          acrylic extensions or any hair removal service - facial, body,
          Brazilian and more.
        </p>
        <p className="max-w-xl my-8">
          If you haven't found your technician yet, please contact me to book
          your visit.
        </p>
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-8 my-24">
          <ContactMeForm />

          <div>
            <div className="font-playfaird text-xl capitalize mb-4">
              Call Me
            </div>
            <div className="mb-8">
              <a
                href={`tel:+1${siteMetadata.phone.replace(/\D/g, "")}`}
                className="underline"
              >
                {siteMetadata.phone}
              </a>
            </div>
            <div className="font-playfaird text-xl capitalize mb-4">
              Get Direction to Salon
            </div>
            <a
              href={siteMetadata.googleBusinessProfileUrl}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="my-4 underline block"
            >
              {siteMetadata.address}
            </a>
            {/* <iframe
              title="googlemap"
              className="w-full min-h-[300px]"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1118877.0112956462!2d-89.42969242466384!3d47.898994753785296!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4d59232a9909af79%3A0xaf90a315985250ed!2sOlya%20Koval%20Nail%20Salon!5e0!3m2!1sen!2sua!4v1659602078496!5m2!1sen!2sua&zoom=13"
              frameBorder="0"
              allowFullScreen
            ></iframe> */}
            <iframe
              title="Olya Koval Nail salon on Google Map"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d169351.9270365272!2d-89.29389667509882!3d48.45438442682064!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4d59232a9909af79%3A0xaf90a315985250ed!2sOlya%20Koval%20Nail%20Salon!5e0!3m2!1sen!2sua!4v1688933227857!5m2!1sen!2sua"
              className="w-full min-h-[300px]"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          <div>
            <div className="mb-8">
              <div className="font-playfaird text-xl capitalize mb-4">
                Working Hours
              </div>
              <ul>
                {siteMetadata.workDays.map(workDay =>
                  workDay.isWeekend ? (
                    <li
                      key={workDay.id}
                      className="w-48 flex justify-between opacity-80"
                    >
                      <span>{workDay.weekday}</span>
                      <span>{`closed`}</span>
                    </li>
                  ) : (
                    <li key={workDay.id} className="w-48 flex justify-between">
                      <span>{workDay.weekday}</span>
                      <span>{`${workDay.timeFrom}-${workDay.timeTo}`}</span>
                    </li>
                  ),
                )}
              </ul>
            </div>
            <div>
              <div className="font-playfaird text-xl capitalize my-4">
                Contact me on social media
              </div>
              <ul>
                <li className="my-2">
                  <a
                    href={`https://facebook.com/${siteMetadata.facebookPageHandle}`}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className=""
                  >
                    <RiFacebookFill className="bg-amber-200 text-slate-900 p-1 w-8 h-8 rounded-full mr-2 inline" />
                    <span>Facebok</span>
                  </a>
                </li>
                <li className="my-2">
                  <a
                    href={`https://instagram.com/${siteMetadata.instagramPageHandle}`}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className=""
                  >
                    <RiInstagramLine className="bg-amber-200 text-slate-900 p-1 w-8 h-8 rounded-full mr-2 inline" />
                    <span>Instagram</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="py-24 px-4 sm:px-8 xl:px-24 text-slate-50">
        <div className="text-4xl md:text-5xl font-playfaird font-medium leading-ok md:leading-ok">
          My Certificates & Diplomas
        </div>
        <hr className="max-w-[200px] my-4 border-amber-200 border" />
        <p className="max-w-xl my-8">
          For more than 15 years in the beauty industry, I improving my
          qualifications constantly. Have certificates and diplomas and take
          additional courses regularly. Since 2014 working as a manicure,
          pedicure and hair removal technician.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {certificates.map(cert => (
            <div key={cert.id} className="my-8">
              <GatsbyImage
                image={getImage(cert.image)}
                alt={cert.title}
                className="mx-auto"
              />
              <div className="font-playfaird text-xl capitalize my-4 text-center">
                {cert.title}
              </div>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  )
}
